<template>
<div class="moveDialog">
    <el-dialog
      title="挪动"
      :visible.sync="status"
      width="30%"
      :close-on-click-modal="false"
    >
      <p style="margin: 10px;"><img src="../img/moveIcon.png" />挪动设备</p>
      <h3 style="margin: 10px;">挪动设备无法挪动设备之前产生的数据，请谨慎操作！</h3>
      <h3 style="margin: 10px;">
        <el-radio v-model="moveonly" label="1">仅挪设备</el-radio>
        <el-radio v-model="moveonly" label="2">挪动设备和监测点</el-radio>
      </h3>
      <el-form>
        <el-form-item label="挪动组织" :label-width="'90px'">
          <el-cascader
            style="width: 100%"
            v-model="deptNameList"
            :show-all-levels="false"
            :options="deptList"
            size="large"
            :props="{ value: 'deptId', label: 'deptName',checkStrictly: true }"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadMove()">确 定</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
export default {
  name: "moveDialog",
  data() {
    return {
      status: false,
      deptList:[],
      checkList:[],
      deptNameList:"",
      moveonly:"1",
    };
  },
  methods: {
    controlDialog(checkList,deptList) {
      this.status = true;
      this.deptList=deptList
      this.checkList=checkList
    },
    uploadMove(){
      let that=this
      if(that.deptNameList){
        let deptName=that.deptNameList[that.deptNameList.length - 1]
        let terminalIds=[]
        for(let i=0;i<this.checkList.length;i++){
          terminalIds.push(this.checkList[i].terminalId)
        }

        let param = {};
        param.method="post";
        param.url="/device/move";
        param.data=
          {
            deptId:deptName,
            terminalIds:terminalIds,
            moveMonitor:this.moveonly=='2'?true:false
          }
        Axios.ajax(param).then((res)=>{

          if(res.resultCode=="0"){
             this.status = false;
            that.$message({
              type: 'success',
              message: "挪动成功"
            });
          }else{
            that.$message({
              type: 'error',
              message:res.resultMessage
            });
          }
        })
      }else{
        that.$message({
          type: 'error',
          message: "请先选择部门"
        });
      }

    }
  },
};
</script>

<style lang="less" scoped>
.moveDialog {
  p {
    margin: 0 0 10px 0;
    height: 30px;
    line-height: 10px;
    img {
      margin-right: 12px;
    }
  }
}
</style>
